export const QUOTES_LOAD_SUCCESS = 'QUOTES_LOAD_SUCCESS';
export const QUOTES_COUNT_SUCCESS = 'QUOTES_COUNT_SUCCESS';
export const QUOTES_MODAL_CLOSE = 'QUOTES_MODAL_CLOSE';
export const QUOTES_PAGE_CHANGE = 'QUOTES_PAGE_CHANGE';
export const QUOTES_SELECTION_SUCCESS = 'QUOTES_SELECTION_SUCCESS';
